import { Link, useLocation } from 'react-router-dom';
import { Home, PieChart, Settings as SettingsIcon } from 'lucide-react';
import { useSettings } from '../hooks/useSettings';

export default function MobileNav() {
  const location = useLocation();
  const { settings } = useSettings();

  const navItems = [
    { name: 'Dashboard', href: '/', icon: Home },
    ...(settings.showPortfolio ? [{ name: 'Portfolio', href: '/portfolio', icon: PieChart }] : []),
    { name: 'Settings', href: '/settings', icon: SettingsIcon },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-black border-t border-gray-200 dark:border-gray-800 px-4 py-2 z-50">
      <div className="flex justify-around">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.href;
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`flex flex-col items-center gap-1 px-3 py-2 rounded-lg transition-all ${
                isActive
                  ? 'text-black dark:text-white'
                  : 'text-gray-500 dark:text-gray-400'
              }`}
            >
              <Icon className="h-6 w-6" />
              <span className="text-xs font-medium">{item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}